/**
 * CWS-1914: where a customer pick on the create-order form goes.
 *
 * Picking a customer by phone can hand the form off to the Active subscription chooser, which
 * is right when the attendant typed the phone and the customer has packages to choose from.
 * It is wrong when the modal was opened to redeem one named prepaid book, by QR or by plate:
 * that scan already chose the book, and the Redeem Prepaid Purchase screen the modal opened
 * with is the one that captures the plate, name, phone and email of whoever came in. The
 * hand-off replaced it with the chooser, which captures none of that.
 */
export interface CustomerPickRouteInput {
  /** The create-order (checkout) layout is showing; the hand-off only exists there. */
  isCheckoutLayout: boolean;
  /** The picked customer's phone; the hand-off looks the customer up by it. */
  phone: string | null | undefined;
  /**
   * The modal was opened to redeem a named prepaid book (QR scan or plate match) and that
   * book still has washes to draw. A used-up or expired book reopens the catalog, and the
   * screen is an ordinary create-order again, so the pick must route normally.
   */
  isLivePrepaidRedeemEntry: boolean;
}

/** True when the pick should run the phone look-up that may open the chooser. */
export function shouldRouteCustomerPickThroughPhoneChooser(input: CustomerPickRouteInput): boolean {
  if (!input.isCheckoutLayout || input.isLivePrepaidRedeemEntry) {
    return false;
  }
  return String(input.phone ?? '').trim().length > 0;
}
